import React from 'react';

const style = {
  a: {
    fill: 'none',
    stroke: '#353535',
    strokeLinecap: 'round',
    strokelinejoin: 'round',
    strokewidth: '1.5px',
  },
};
export default function SvgGreenroomIcon(props) {
  return (
    <svg width="240" height="239" viewBox="0 0 240 239" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M235 0.000976562C237.761 0.000976562 240 2.23971 240 5.00098V234.001C240 236.762 237.761 239.001 235 239.001H5C2.23858 239.001 0 236.762 0 234.001V5.00098C0.000181693 2.23971 2.23869 0.000976643 5 0.000976562H235ZM179.535 84.9658C175.052 84.9658 171.418 88.62 171.418 93.127V109.652H68.583V93.127C68.5829 88.62 64.9488 84.9658 60.4658 84.9658C55.983 84.966 52.3487 88.6201 52.3486 93.127V117.812C52.3486 122.319 55.9829 125.973 60.4658 125.974H77.1982L108.07 154.794L63.2812 196.606C59.997 199.673 59.8066 204.836 62.8564 208.139C65.9069 211.441 71.0441 211.632 74.3291 208.565L119.999 165.93L165.671 208.565C168.956 211.632 174.093 211.441 177.144 208.139C180.193 204.836 180.003 199.673 176.719 196.606L131.929 154.794L162.802 125.974H179.535C184.018 125.973 187.652 122.319 187.652 117.812V93.127C187.652 88.6202 184.018 84.966 179.535 84.9658ZM138.942 125.974L119.999 143.657L101.058 125.974H138.942ZM75.8721 38.8574C72.8835 38.8574 70.46 41.2933 70.46 44.2979V85.3574C70.4601 88.362 72.8835 90.7979 75.8721 90.7979H164.129C167.117 90.7979 169.541 88.362 169.541 85.3574V44.2979C169.541 41.2933 167.118 38.8574 164.129 38.8574H75.8721Z" fill="url(#paint0_linear_2588_31106)" />
      <defs>
        <linearGradient id="paint0_linear_2588_31106" x1="107.5" y1="0.00097429" x2="159.583" y2="239.092" gradientUnits="userSpaceOnUse">
          <stop stopColor="#CBFF47" />
          <stop offset="1" stopColor="#405212" />
        </linearGradient>
      </defs>
    </svg>

  );
}
